<template>
  <div align="left">
    <b-tabs vertical pills>
      <b-tab title="Signed Representations"><representations/></b-tab>
      <b-tab title="Addition"><addition/></b-tab>
      <b-tab title="Sign Extension"><signExtension/></b-tab>
      <b-tab title="Ranges"><ranges/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import representations from '@/components/representations'
import addition from '@/components/addition'
import signExtension from '@/components/sign-extension'
import ranges from '@/components/signed-ranges'

export default {
  name: 'Signed',
  components: {
    representations,
    addition,
    signExtension,
    ranges
  }
}
</script>



// WEBPACK FOOTER //
// src/components/signed.vue